// tslint:disable-next-line: no-default-export

export const calls = [
  {
    name: 'GetAppInfo',
    call: 'GetAppInfo',
    params: {},
    isSendJson: true,
  },
  {
    name: 'GetUserInfo',
    call: 'GetUserInfo',
    params: {},
    isSendJson: true,
  },
  {
    name: 'BindPhone',
    call: 'BindPhone',
    params: {},
    isSendJson: true,
  },
  {
    name: 'RealNameAuth',
    call: 'RealNameAuth',
    params: {},
    isSendJson: true,
  },
  {
    name: 'Login',
    call: 'Login',
    params: {
      gid: ['isInt', 'required'],
      gameid: ['isInt', 'required'],
      packetid: ['isInt', 'required'],
    },
    transformer: {
      gid: 'toNumber',
      gameid: 'toNumber',
      packetid: 'toNumber',
    },
    isSendJson: true,
  },
  {
    name: 'DoCharge',
    call: 'DoCharge',
    params: {
      gid: ['isInt', 'required'],
      gameid: ['isInt', 'required'],
      packetid: ['isInt', 'required'],
      warename: ['isString', 'required'],
      paybill: ['isInt', 'required'],
      count: ['isInt', 'required'],
      serverid: ['isString', 'required'],
      servername: ['isString', 'required'],
      roleid: ['isString', 'required'],
      rolename: ['isString', 'required'],
      rolelevel: ['isString', 'required'],
      extstr: ['isString', 'required'],
      timestamp: ['isString', 'optional'],
      signature: ['isString', 'optional'],
    },
    transformer: {
      gid: 'toNumber',
      gameid: 'toNumber',
      packetid: 'toNumber',
      paybill: 'toNumber',
    },
    isSendJson: true,
  },
  {
    name: 'Save',
    call: 'Save',
    params: {
      type: ['isInt', 'required'],
      gid: ['isInt', 'required'],
      gameid: ['isInt', 'required'],
      packetid: ['isInt', 'required'],
      serverid: ['isString', 'required'],
      servername: ['isString', 'required'],
      roleid: ['isString', 'required'],
      rolename: ['isString', 'required'],
      rolelevel: ['isString', 'required'],
    },
    transformer: {
      type: 'toNumber',
      gid: 'toNumber',
      gameid: 'toNumber',
      packetid: 'toNumber',
    },
    isSendJson: true,
  },
  {
    name: 'Ucenter',
    call: 'Ucenter',
    params: {},
    isSendJson: true,
  },
  {
    name: 'Webview',
    call: 'Webview',
    params: {
      src: ['isString', 'required'],
      title: ['isString', 'optional'],
      fullscreen: ['isBoolean', 'optional'],
      orientation: ['isString', 'optional'],
    },
    isSendJson: true,
  },
  {
    name: 'CloseWebview',
    call: 'CloseWebview',
    params: {},
    isSendJson: true,
  },
  {
    name: 'PlayVideo',
    call: 'PlayVideo',
    params: {
      src: ['isString', 'required'],
      title: ['isString', 'optional'],
      poster: ['isString', 'optional'],
      autoplay: ['isBoolean', 'optional'],
    },
    isSendJson: true,
  },
  {
    name: 'ShowImageView',
    call: 'ShowImageView',
    params: {
      list: ['isArray', 'required'],
    },
    isSendJson: true,
  },
  {
    name: 'Navigator',
    call: 'Navigator',
    params: {
      menuid: ['isInt', 'required'],
    },
    isSendJson: true,
  },
  {
    name: 'SetScreenOrientation',
    call: 'SetScreenOrientation',
    params: {
      orientation: ['isString', 'required'], // 横屏：'vertical'或者'portrait', 竖屏：'horizontal'或者'landscape'
    },
    isSendJson: true,
  },
  {
    name: 'GetScreenOrientation',
    call: 'GetScreenOrientation',
    params: {},
    isSendJson: true,
  },
  {
    name: 'LockFullscreen',
    call: 'LockFullscreen',
    params: {},
    isSendJson: true,
  },
  {
    name: 'UnlockFullscreen',
    call: 'UnlockFullscreen',
    params: {},
    isSendJson: true,
  },
  {
    name: 'testSyn',
    call: 'testSyn',
    params: {},
    isSendJson: true,
  },
  {
    name: 'testAsyn',
    call: 'testAsyn',
    params: {
      hello: ['isString', 'required'],
    },
    isSendJson: true,
  },
];
